import { Component, Injectable, inject, input, signal, computed, ChangeDetectionStrategy } from '@angular/core';
import { SupabaseService } from '../../services/supabase.service';
import { TranslatePipe } from '../../pipes/translate.pipe';

@Injectable({ providedIn: 'root' })
export class RegisteredParticipants {
  private supabase = inject(SupabaseService);
  readonly ids = signal<Set<string>>(new Set());
  constructor() { void this.load(); }
  private async load() {
    const ids = new Set<string>();
    for (let offset = 0; ; offset += 1000) {
      const { data, error } = await this.supabase.client.from('humans').select('id')
        .not('profile_id', 'is', null).order('id').range(offset, offset + 999);
      if (error) { console.error('Unable to load registered participant badges', error); return; }
      for (const row of data || []) ids.add(row.id);
      if (!data || data.length < 1000) break;
    }
    this.ids.set(ids);
  }
}

@Component({
  selector: 'app-registered-star',
  standalone: true,
  imports: [TranslatePipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `@if (registered()) { <span class="ml-1 inline-flex align-middle text-amber-500" role="img" [attr.aria-label]="'common.registeredParticipant' | translate" [attr.title]="'common.registeredParticipant' | translate"><svg class="h-3.5 w-3.5" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="m12 2.5 2.9 5.9 6.5.9-4.7 4.6 1.1 6.5-5.8-3.1-5.8 3.1 1.1-6.5-4.7-4.6 6.5-.9L12 2.5Z"/></svg></span> }`,
})
export class RegisteredStarComponent {
  humanId = input<string | null | undefined>();
  private participants = inject(RegisteredParticipants);
  registered = computed(() => !!this.humanId() && this.participants.ids().has(this.humanId()!));
}
